// extracted by mini-css-extract-plugin
module.exports = {"paymentIcons":"paymentIcons_paymentIcons__g6ypz","iconContainer":"paymentIcons_iconContainer__QO1dB","noBorder":"paymentIcons_noBorder__ESNDw","icon":"paymentIcons_icon__ck4TI"};